import { render, staticRenderFns } from "./AromaPaySection.vue?vue&type=template&id=7432baac&scoped=true"
import script from "./AromaPaySection.vue?vue&type=script&lang=js"
export * from "./AromaPaySection.vue?vue&type=script&lang=js"
import style0 from "./AromaPaySection.vue?vue&type=style&index=0&id=7432baac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7432baac",
  null
  
)

export default component.exports